import * as THREE from "three";
import { World } from "./World";
import { vSkyHatchShader, fSkyHatchShader, vDefaultShader, fBasicGammaShader} from '../shaders/';

export class LittleRedWorld extends World {
    constructor({name, model, assets}) {
        super({name, model, assets})
        this.camera.near = 0.1;
        this.camera.far = 100;
        this.titleBrightness = 1;
        this.titleDisplace = -0.2;
        this.titleScale = 0.8;
    }

    processModel() {
        super.processModel();

        this.sky = this.model.scene.getObjectByName("sky");
        this.matSky = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: null },
                hatchingScale: { value: 10 },
                hatchingMap: { value: this.assets.textures.hatchC },
                gamma: {value: 1.7},
                mixDiffuse: { value: 0 },
                whiteLevel: { value: 1 },
                blackLevel: { value: 0 },
                time: { value: 0 },
            },
            vertexShader: vSkyHatchShader,
            fragmentShader: fSkyHatchShader,
        })
        this.matSky.uniforms.map.value = this.sky.material.map
        this.sky.material = this.matSky;

        this.character = this.model.scene.getObjectByName("character");
        this.basicGammaMat = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: null },
                gamma: {value: 1.2},
            },
            vertexShader: vDefaultShader,
            fragmentShader: fBasicGammaShader,
            side: THREE.DoubleSide,
        })
        this.basicGammaMat.uniforms.map.value = this.character.material.map
        this.character.material = this.basicGammaMat

    }
}